import * as React from 'react';
import {useReleaseFlag} from 'src/hooks/product-flags';
import useAgencyConfig from 'src/hooks/useAgencyConfig';
import {useSelector} from 'react-redux';
import css from 'src/components/lib/messaging-input/url-highlight-message.css';


type Props = {
  children: React.ReactNode;
};

const UrlHighlightMessage = ({children}: Props) => {
  const isLinkShorteningFlagEnabled = useReleaseFlag(
    'enableMessagingLinkShortening',
  );
  const isLinkShorteningAgencyConfigEnabled = Boolean(
    useAgencyConfig('messagingLinkShorteningEnabled'),
  );
  const shortenLinkSettingEnabled = useSelector(
    // @ts-expect-error - TS2339 - Property 'agentSettings' does not exist on type 'DefaultRootState'.
    (state) => state.agentSettings.messagingEnableLinkShortening,
  );
  const shouldHighlightUrl =
    isLinkShorteningFlagEnabled &&
    isLinkShorteningAgencyConfigEnabled &&
    shortenLinkSettingEnabled;

  // Only render the highlighted URL if conditions are met
  if (shouldHighlightUrl) {
    return <span className={css.urlHighlight}>{children}</span>;
  }

  return <span>{children}</span>;
};

export default UrlHighlightMessage;
